// Copyright (C) 2020 TANNER AG

import gql from 'graphql-tag'
import { FullPodcastsFragment } from "./podcasts";

export default gql`
    query Podcasts(
        $id: ID!
        $lang: [Locale!]!
        $stage: Stage!
    ) {
        podcast(where: { id: $id } locales: $lang stage: $stage) {
            ...FullPodcastsFragment
        }
    }
    ${FullPodcastsFragment}
`;



// WEBPACK FOOTER //
// ./src/queries/podcast.js